/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function callPhone(params) {
    var phoneNumber = params.phoneNumber, success = params.success, fail = params.fail;
    try {
        window.location.href = "tel:".concat(phoneNumber);
        success === null || success === void 0 ? void 0 : success(); // set resolved。跟universal-api web端保持一致返回。https://github.com/raxjs/universal-api/blob/master/src/packages/device/makePhoneCall/src/web/index.ts
    }
    catch (error) {
        fail === null || fail === void 0 ? void 0 : fail();
    }
}

export { callPhone as default };
